// extracted by mini-css-extract-plugin
module.exports = {"loading":"dialog-info_loading__E4e7i","controls":"dialog-info_controls__2mtTW"};